export default __webpack_public_path__ + "static/media/art-pro-blk-poster-3.7cab86eb.jpg";